import {Image, ImageProps} from '@chakra-ui/react';

import starsEyes from './stars-eyes.png';

export const StarsEyesIcon = (props: ImageProps) => <Image src={starsEyes.src} alt="" objectFit="contain" {...props} />;
